import moment from 'moment'

export const OPENING_BALANCE = 'Opening Balance'
export const LATE_PAYMENT_AWARENESS = 'Aware'
export const VERIFIED_INCOME = 'Aware'

export function isIncome(activity){
	return activity && (activity.income || (activity.amount > 0 && !isPayment(activity) && !isOpeningBalance(activity)))
}

export function isOpeningBalance(activity){
	return activity && (activity.id === 0 || activity.streamName == OPENING_BALANCE)
}

export function isPayment(activity){
	return activity && (activity.paymentMethod || activity.streamTypeId)
}

export function isAware(activity){
	if(activity && typeof activity == 'object'){
		return activity.clientAwareness == LATE_PAYMENT_AWARENESS
	}else{
		return activity == LATE_PAYMENT_AWARENESS
	}
}

export function isLate(activity){
	if(activity && activity.dateDue && activity.datePayable){
		return moment(activity.datePayable) > moment(activity.dateDue)
	}
	return false
}

export function isEditable(isOnHold, paymentMethod){
	return isOnHold && (['B' /* BPAY */, 'D' /* Direct Credit */, 'C' /* Cheque */, 'Z', 'S' /* Savings */].includes(paymentMethod))
}

export function areEqual(activity1, activity2){
	const getCoreActivityData = (activity) => {
		const a = activity || {}

		return {
			id: a.id,
			dateDue: a.dateDue,
			datePayable: a.datePayable,
			amount: a.amount,
			isOnHold: a.isOnHold,
			priority: a.priority,
			runningBalance: a.runningBalance
		}
	}

	const a1 = getCoreActivityData(activity1)
	const a2 = getCoreActivityData(activity2)

	let activitiesEqual = true
	for(var propertyName in a1){
		if(a1[propertyName] !== a2[propertyName]){
			activitiesEqual = false
			break
		}
	}
	return activitiesEqual
}

export function priorWorkday(date, days=1){
	let d = date instanceof Date ? date : moment.utc(date, 'DD-MM-YYYY').toDate()
	let priorDay = moment.utc(d).subtract(days, 'day')
	const day = priorDay.day()

	if(day === 6) priorDay = priorDay.subtract(1, 'day')
	if(day === 0) priorDay = priorDay.subtract(2, 'day')

	return priorDay.toDate()
}




// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/util/activity.js